import { render } from "./index-review.vue?vue&type=template&id=1624b090"
import script from "./index-review.vue?vue&type=script&lang=js"
export * from "./index-review.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__